import type { SVGProps } from 'react'

const IntegratedDataIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_170_31432)">
      <circle
        cx="15.0002"
        cy="14.999"
        r="8.96"
        stroke="black"
        strokeWidth="1.12"
      />
      <path
        d="M15.2312 5.93994V14.299M15.2312 14.299L23.5902 17.3175M15.2312 14.299L17.321 23.5868"
        stroke="black"
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C19.3237 1 23.1896 2.96001 25.7577 6.04"
        stroke="#0066FF"
        strokeWidth="1.12"
        strokeLinecap="round"
      />
      <path
        d="M23.3994 6.04219L26.7594 6.60219L26.1994 3.24219"
        stroke="#0066FF"
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_170_31432">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default IntegratedDataIcon
